// extracted by mini-css-extract-plugin
export default {"root":"FieldLabel_root__SKXmA","required":"FieldLabel_required__fI1MV","optional":"FieldLabel_optional__wRz-I"};